<div class="flex items-center justify-between px-4">
  <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ data.title || 'Determinación de Cuentas' }}</h2>
  <button mat-flat-button color="primary" (click)="addRow()">Añadir Oficina</button>
</div>

<mat-dialog-content [ngStyle]="multiMode ? {'max-height': '90vh', 'overflow-y': 'auto'} : {}">
  <!-- MODO MULTIMODE: ACCORDION -->
  <ng-container *ngIf="multiMode; else tableMode">
    <mat-accordion multi class="mt-4">
      <mat-expansion-panel *ngFor="let brand of dataSource; let i = index" 
        [expanded]="expandedIndex === i"
        (opened)="expandedIndex = i"
        (closed)="expandedIndex = null"
        [formGroup]="brand">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Oficina: {{ getOfficeName(brand.get('salesOfficeId')?.value) }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Oficina de Venta -->
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Oficina de Venta</mat-label>
          <mat-select formControlName="salesOfficeId" required>
            <mat-option *ngFor="let office of salesOfficeList" [value]="office._id">
              {{ office.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="brand?.get('salesOfficeId')?.hasError('required')">Requerido</mat-error>
        </mat-form-field>

        <!-- Datos Marca -->
        <app-form-section title="DATOS CONTABLES MARCA" icon="business" iconColor="purple">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <mat-form-field appearance="fill">
              <mat-label>Cuenta Contable</mat-label>
              <input matInput formControlName="accountingAccount" />
              <mat-error *ngIf="brand?.get('accountingAccount')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Centro de Costo</mat-label>
              <input matInput formControlName="costCenter" />
              <mat-error *ngIf="brand?.get('costCenter')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Clave Contable</mat-label>
              <input matInput formControlName="accountingKey" />
              <mat-error *ngIf="brand?.get('accountingKey')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>
          </div>
        </app-form-section>

        <!-- Datos Comisión -->
        <app-form-section title="DATOS CONTABLES COMISIÓN" icon="attach_money" iconColor="green">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <mat-form-field appearance="fill">
              <mat-label>Cuenta Contable</mat-label>
              <input matInput formControlName="com_accountingAccount" />
              <mat-error *ngIf="brand?.get('com_accountingAccount')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Centro de Costo</mat-label>
              <input matInput formControlName="com_costCenter" />
              <mat-error *ngIf="brand?.get('com_costCenter')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Clave Contable</mat-label>
              <input matInput formControlName="com_accountingKey" />
              <mat-error *ngIf="brand?.get('com_accountingKey')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>
          </div>
        </app-form-section>

        <!-- Datos Retención -->
        <app-form-section title="DATOS CONTABLES RETENCIÓN" icon="account_balance" iconColor="red">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <mat-form-field appearance="fill">
              <mat-label>Cuenta Contable</mat-label>
              <input matInput formControlName="ret_accountingAccount" />
              <mat-error *ngIf="brand?.get('ret_accountingAccount')?.hasError('required')">Requerido</mat-error>            
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Centro de Costo</mat-label>
              <input matInput formControlName="ret_costCenter" />
              <mat-error *ngIf="brand?.get('ret_costCenter')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Clave Contable</mat-label>
              <input matInput formControlName="ret_accountingKey" />
              <mat-error *ngIf="brand?.get('ret_accountingKey')?.hasError('required')">Requerido</mat-error>
            </mat-form-field>
          </div>
        </app-form-section>
        
        <app-toggle-option
          title="Estado"
          icon="tune"
          iconColor="blue"
          formControlName="statusId"
          (valueChange)="onStatusChange($event, i)">
        </app-toggle-option>

        <mat-action-row>
          <button mat-stroked-button color="primary" (click)="saveRow(i)" [disabled]="brand.invalid">Guardar</button>
          <button mat-stroked-button color="warn" (click)="removeRow(i)">Eliminar</button>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
    <div *ngIf="dataSource.length === 0" class="text-center text-gray-500 py-4">
      Sin oficinas aún.
    </div>
  </ng-container>

  <!-- MODO SIMPLE: TABLA -->
  <ng-template #tableMode>
    <div style="max-height: 70vh; overflow-y: auto;">
    <table mat-table [dataSource]="dataSource" class="w-full">
      <!-- Oficina -->
      <ng-container matColumnDef="salesOffice">
        <th mat-header-cell *matHeaderCellDef> Oficina de Venta </th>
        <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
          <mat-form-field appearance="fill" class="w-full py-1 px-2">
            <mat-select formControlName="salesOfficeId" required>
              <mat-option *ngFor="let office of salesOfficeList" [value]="office._id">
                {{ office.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="row?.get('salesOfficeId')?.hasError('required')">Requerido</mat-error>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Cuenta contable -->
      <ng-container matColumnDef="account">
        <th mat-header-cell *matHeaderCellDef> Cuenta Contable </th>
        <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
          <mat-form-field appearance="fill" class="w-full py-1 px-2">
            <input matInput formControlName="accountingAccount" required />
            <mat-error *ngIf="row?.get('accountingAccount')?.hasError('required')">Requerido</mat-error>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Centro de costos -->
      <ng-container matColumnDef="costCenter">
        <th mat-header-cell *matHeaderCellDef> Centro de Costos </th>
        <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
          <mat-form-field appearance="fill" class="w-full py-1 px-2">
            <input matInput formControlName="costCenter" required />
            <mat-error *ngIf="row?.get('costCenter')?.hasError('required')">Requerido</mat-error>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Clave contable -->
      <ng-container matColumnDef="postingKey">
        <th mat-header-cell *matHeaderCellDef> Clave Cont. </th>
        <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
          <mat-form-field appearance="fill" class="w-full py-1 px-2">
            <input matInput formControlName="accountingKey" required />
            <mat-error *ngIf="row?.get('accountingKey')?.hasError('required')">Requerido</mat-error>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="statusId">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
          <div class="mb-2">
          <mat-slide-toggle
            class="custom-slide-toggle primary"
            [checked]="row.get('statusId')?.value === 1"
            (change)="onStatusChange($event.checked, i)"
            color="primary">
          </mat-slide-toggle>
          </div>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center px-4 py-2">Acciones</th>
        <td mat-cell *matCellDef="let row; let i = index" class="text-center" [formGroup]="row">
          <div class="flex justify-center items-center gap-x-2 mb-2">
            <button mat-icon-button color="primary" (click)="saveRow(i)" [disabled]="row.invalid">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="removeRow(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row text-center" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">Sin oficinas aún.</td>
      </tr>
    </table>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
</mat-dialog-actions>
